<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <v-dialog v-model="dialog" max-width="70%" :fullscreen="$vuetify.breakpoint.mdAndDown">
    <v-card v-if="selectedProvince" dark color="rgba(29,27,65)">
      <v-card-title class="title pink darken-1 white--text" ref="scrollTopHeader">
        {{'Breakdown for ' + selectedProvince.provinceStats.province}}
        <v-btn
          icon
          dark
          @click.native="selectedProvince = null; dialog = false"
          style="position: absolute;right: 10px;top: 10px;"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="mb-5 pa-2 mt-3" style="background-color: rgba(216, 27, 96, 0.3);">
           <v-icon size="18" class="mr-1" color="yellow darken-2">warning</v-icon>
          <span class="caption grey--text mr-1" style="font-size: 14px !important;font-weight: 300;">IMPORTANT NOTE</span>
          <div class="caption white--text text--lighten-2 mt-1" style="font-size: 14px !important;font-weight: 300;">
            Province breakdown stats are sourced as-is from each Province's Health Department or Office of the Premier if and when they are released to the public.
            <br />The breakdown stats and rate of update may therefore differ from the stats in the rest of the dashboard as released by the National Department of Health.
          </div>
        </div>
        <v-row>
          <v-col cols="6" class="pb-0">
            <div class="mb-4 pl-2">
              <span
                class="caption grey--text mr-1"
                style="font-weight: 300;text-transform: uppercase;"
              >{{'LAST UPDATE RELEASED BY ' + selectedProvince.provinceStats.province + ' PROVINCE:' }}</span>
              <div class="caption grey--text text--lighten-2">{{selectedProvince.provinceStats.date}}</div>
            </div>
          </v-col>
          <v-col cols="6" class="pb-0">
            <div class="mb-4 pl-2">
              <span
                class="caption grey--text mr-1"
                style="font-weight: 300;text-transform: uppercase;"
              >SOURCE:</span>
              <a
                :href="selectedProvince.provinceStats.source"
                target="_blank"
                class="caption"
              >{{selectedProvince.provinceStats.source}}</a>
            </div>
          </v-col>
        </v-row>

        <v-row class="pa-4">
          <v-col cols="12" lg="8" class="pb-0">
            <v-card dark color="blue darken-2" class="text-center pa-2" style="min-height: 115px;">
              <div class="title">Totals</div>
              <div>
                <v-row class="pt-2">
                  <v-col cols="6" md="3">
                    <div v-bind:class="[{ 'headline': $vuetify.breakpoint.mdAndUp }]">
                      <v-icon v-if="selectedProvince.nationalCount != selectedProvince.provinceStats.confirmed" size="18" class="mr-1" color="yellow darken-2"
                      title="Province breakdown stats are sourced as-is from each Province's Health Department or Office of the Premier if and when they are released to the public.The breakdown stats and rate of update may therefore differ from the stats in the rest of the dashboard as released by the National Department of Health.">
                      warning</v-icon>
                      {{selectedProvince.nationalCount}}
                    </div>
                    <div class="caption">Latest Confirmed by National</div>
                  </v-col>
                  <v-col cols="6" md="3">
                    <div v-bind:class="[{ 'headline': $vuetify.breakpoint.mdAndUp }]">
                      <v-icon v-if="selectedProvince.nationalCount != selectedProvince.provinceStats.confirmed" size="18" class="mr-1" color="yellow darken-2"
                      title="Province breakdown stats are sourced as-is from each Province's Health Department or Office of the Premier if and when they are released to the public.The breakdown stats and rate of update may therefore differ from the stats in the rest of the dashboard as released by the National Department of Health.">
                      warning</v-icon>
                      {{selectedProvince.provinceStats.confirmed}}
                    </div>
                    <div class="caption">Latest Confirmed by the Province</div>
                  </v-col>
                  <v-col cols="4" md="2">
                    <div v-bind:class="[{ 'headline': $vuetify.breakpoint.mdAndUp }]">{{selectedProvince.provinceStats.recovered}}</div>
                    <div class="caption">Recovered</div>
                  </v-col>
                  <v-col cols="4" md="2">
                    <div v-bind:class="[{ 'headline': $vuetify.breakpoint.mdAndUp }]">{{selectedProvince.provinceStats.deceased}}</div>
                    <div class="caption">Deaths</div>
                  </v-col>
                  <v-col cols="4" md="2">
                    <div v-bind:class="[{ 'headline': $vuetify.breakpoint.mdAndUp }]">{{selectedProvince.provinceStats.tests}}</div>
                    <div class="caption">Tests</div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" lg="4" class="pb-0">
            <v-card
              dark
              color="rgb(35, 122, 113)"
              class="text-center pa-2"
              style="min-height: 150px;"
            >
              <div class="title">Serious/Critical State</div>
              <div>
                <v-row class="pt-2">
                  <v-col cols="6">
                    <div v-bind:class="[{ 'headline': $vuetify.breakpoint.mdAndUp }]">{{selectedProvince.provinceStats.hospital}}</div>
                    <div class="caption">In Hospital</div>
                  </v-col>
                  <v-col cols="6">
                    <div v-bind:class="[{ 'headline': $vuetify.breakpoint.mdAndUp }]">{{selectedProvince.provinceStats.icu}}</div>
                    <div class="caption">In ICU</div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <div class="subheading pa-1 pl-2" style="font-weight: 400; text-transform: uppercase; background-color: rgba(5,151,110,0.3); text-align: center;">{{selectedProvince.provinceStats.vaccines + ' Vaccines Administered' }}</div>

        <v-row class="ml-4 mr-4" style="background-color: #161531; margin-top: 60px;">
          <v-col cols="12" lg="3">
            <v-card dark flat class="pa-3" color="transparent" style="text-align: center; height: 100%;">
              <div><v-icon dark size="40" color="purple lighten-1">place</v-icon></div>
              <div class="headline mt-3">{{selectedProvMost}}</div>      
              <div class="caption grey--text text--lighten-2 mt-2">MOST CONFIRMED CASES REGION</div>
            </v-card>
          </v-col>
          <v-col cols="12" lg="3">
              <v-card dark flat class="pa-3" color="transparent" style="text-align: center; height: 100%;">
                <div><v-icon dark size="40" color="purple lighten-1">person</v-icon></div>
                <div class="headline mt-3">{{selectedProvPop + 'M'}}</div>      
                <div class="caption grey--text text--lighten-2 mt-2">TOTAL POPULATION</div>
              </v-card>
          </v-col>
          <v-col cols="12" lg="3">
              <v-card dark flat class="pa-3" color="transparent" style="text-align: center; height: 100%;">
                <div><v-icon dark size="40" color="purple lighten-1">people</v-icon></div>
                <div class="headline mt-3">{{selectedProvPopPerc + '%'}}</div>      
                <div class="caption grey--text text--lighten-2 mt-2">% OF SA POPULATION</div>
              </v-card>
          </v-col>
          <v-col cols="12" lg="3">
              <v-card dark flat class="pa-3" color="transparent" style="text-align: center; height: 100%;">
                <div><v-icon dark size="40" color="purple lighten-1">house</v-icon></div>
                <div class="headline mt-3">{{'Level ' + selectedProvLevel}}</div>      
                <div class="caption grey--text text--lighten-2 mt-2">LOCKDOWN RESTRICTION</div>
              </v-card>
          </v-col>
        </v-row>
        <v-row class="pl-5 pr-5 mt-5">
          <apexchart type="bar" height="500" style="width: 100%;" :options="chartOptions" :series="series"></apexchart>
        </v-row>
        <v-row class="pl-5 pr-5" style="margin-top: 60px;">
          <v-col cols="3" lg="3" class="pa-0 ma-0 text-left">
            <div
              class="pl-5 caption grey--text text--lighten-1"
              v-bind:style="{ 'font-size': $vuetify.breakpoint.smAndDown? '12px !important': '14px !important', 'font-weight': '400', 'text-transform': 'uppercase' }"
            >Region</div>
          </v-col>
          <v-col cols="3" lg="3" class="pa-0 ma-0 text-center">
            <div
              class="caption blue--text text--lighten-1"
              v-bind:style="{ 'font-size': $vuetify.breakpoint.smAndDown? '12px !important': '14px !important', 'font-weight': '400', 'text-transform': 'uppercase' }"
            >Confirmed</div>
          </v-col>
          <v-col cols="3" lg="3" class="pa-0 ma-0 text-center">
            <div
              class="caption green--text"
              v-bind:style="{ 'font-size': $vuetify.breakpoint.smAndDown? '12px !important': '14px !important', 'font-weight': '400', 'text-transform': 'uppercase' }"
            >Recovered</div>
          </v-col>
          <v-col cols="3" lg="3" class="pa-0 ma-0 text-center">
            <div
              class="caption pink--text text--lighten-1"
              v-bind:style="{ 'font-size': $vuetify.breakpoint.smAndDown? '12px !important': '14px !important', 'font-weight': '400', 'text-transform': 'uppercase' }"
            >Deaths</div>
          </v-col>
        </v-row>
        <div v-for="dist in selectedProvince.districts" :key="dist.district_munic">
          <v-row class="pl-5 pr-5 mt-5 pb-3" style="background-color: #161531;">
            <v-col cols="3" lg="3" class="pb-0">
              <div v-bind:class="[{ 'title': $vuetify.breakpoint.mdAndUp }, { 'caption': $vuetify.breakpoint.smAndDown }]" style="font-weight: 400;">{{dist.district_munic}}</div>
            </v-col>
            <v-col cols="3" lg="3" class="pb-0 text-center">
              <div v-bind:class="[{ 'title': $vuetify.breakpoint.mdAndUp }, { 'caption': $vuetify.breakpoint.smAndDown }, 'blue--text text--lighten-1']" style="font-weight: 400;">{{dist.district_munic_confirmed}}</div>
            </v-col>
            <v-col cols="3" lg="3" class="pb-0 text-center">
              <div v-if="recoveredRunningTotal > 0" v-bind:class="[{ 'title': $vuetify.breakpoint.mdAndUp }, { 'caption': $vuetify.breakpoint.smAndDown }, 'green--text']" style="font-weight: 400;">{{dist.district_munic_recovered}}</div>
              <div v-else v-bind:class="[{ 'title': $vuetify.breakpoint.mdAndUp }, { 'caption': $vuetify.breakpoint.smAndDown }, 'green--text']" style="font-weight: 400;">Unknown</div>
            </v-col>
            <v-col cols="3" lg="3" class="pb-0 text-center">
              <div v-if="deceasedRunningTotal > 0" v-bind:class="[{ 'title': $vuetify.breakpoint.mdAndUp }, { 'caption': $vuetify.breakpoint.smAndDown }, 'pink--text text--lighten-1']" style="font-weight: 400;">{{dist.district_munic_deceased}}</div>
              <div v-else v-bind:class="[{ 'title': $vuetify.breakpoint.mdAndUp }, { 'caption': $vuetify.breakpoint.smAndDown }, 'pink--text text--lighten-1']" style="font-weight: 400;">Unknown</div>
            </v-col>
          </v-row>
          <div v-if="dist.hasLocals" style="margin-bottom: 60px;">
            <apexchart type="bar" :height="dist.localChartHeight" :options="dist.localChartOptions" :series="dist.localsSeries" v-bind:style="{ 'width': $vuetify.breakpoint.smAndDown? '100%' : '50%' }"></apexchart>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Papa from "papaparse";

export default {
  name: "ProvinceBreakdown",
  data: () => ({
    dialog: false,
    selectedProvince: null,
    recoveredRunningTotal: 0,
    deceasedRunningTotal: 0,
    selectedProvMost: "",
    selectedProvPop: "",
    selectedProvPopPerc: "",
    selectedProvLevel: "",
    series: [{
        name: "Confirmed",
        data: []
      },
      {
        name: "Recovered",
        data: []
      },
      {
        name: "Deaths",
        data: []
      }],
    chartOptions: {
      colors: ["#008FFB", "#4CAF50", "#e91e63"],
      theme: {
        mode: "dark",
        palette: "palette10"
      },
      chart: {
        background: "rgba(29,27,65)",
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
        }
      },
      grid: {
        //show: false,
        borderColor: "rgb(27, 36, 77)"
      },
      dataLabels: {
        enabled: true
      },
      xaxis: {
        categories: []
      },
      title: {
        text: "Cases per region",
        offsetY: 10,
        align: 'center',
        style: {
          fontSize: "16px",
          fontWeight: 400
        }
      }
    }
  }),
  methods: {
    loadProvince(provinceStats, nationalCount, breakdownRegions, selectedProvMost, selectedProvPop, selectedProvPopPerc, selectedProvLevel) {
      var self = this
      
      this.recoveredRunningTotal = 0
      this.deceasedRunningTotal = 0
      this.selectedProvMost = selectedProvMost
      this.selectedProvPop = selectedProvPop
      this.selectedProvPopPerc = selectedProvPopPerc
      this.selectedProvLevel = selectedProvLevel 
      
      var selProv = { provinceStats: provinceStats, districts: [], nationalCount: nationalCount };

      //sort data grouped by districts
        var dists = [];

        //filter out this province data only
        var provData = breakdownRegions.filter(d => d.province === provinceStats.province);

        for (var i = 0; i < provData.length; i++) {
          var match = dists.find(
            d => d.district_munic === provData[i].district_munic
          );
          if (match) {
            //update the record
            match.district_munic_confirmed += provData[i].confirmed * 1;
            match.district_munic_recovered += provData[i].recovered * 1;
            match.district_munic_deceased += provData[i].deceased * 1;
            match.local_munics.push(provData[i]);

            //update running totals
            self.recoveredRunningTotal += provData[i].recovered * 1;
            self.deceasedRunningTotal += provData[i].deceased * 1;

          } else {
            //not found
            dists.push({
              district_munic: provData[i].district_munic,
              district_munic_confirmed: provData[i].confirmed * 1,
              district_munic_recovered: provData[i].recovered * 1,
              district_munic_deceased: provData[i].deceased * 1,
              local_munics: [provData[i]]
            });

            //update running totals
            self.recoveredRunningTotal += provData[i].recovered * 1;
            self.deceasedRunningTotal += provData[i].deceased * 1;

          }
        }

        //sort by count desc
        dists = dists.sort(function(a, b) {
          a = a.district_munic_confirmed;
          b = b.district_munic_confirmed;
          return a > b ? -1 : a < b ? 1 : 0;
        });

        //sort local munics
        for (var i = 0; i < dists.length; i++) {
          //sort by count desc
          dists[i].local_munics = dists[i].local_munics.sort(function(a, b) {
            a = a.confirmed * 1;
            b = b.confirmed * 1;
            return a > b ? -1 : a < b ? 1 : 0;
          });

          //get local munic graph data
          var locseries = [{name:"Confirmed", data:[]},{name:"Recovered", data:[]},{name:"Deaths", data:[]}]
          var locchartOptions = {
            colors: ["#008FFB", "#4CAF50", "#e91e63"],
            theme: {
                mode: "dark",
                palette: "palette10"
              },
              chart: {
                background: "rgba(29,27,65)",
                toolbar: {
                  show: false
                }
              },
              plotOptions: {
                bar: {
                  horizontal: true,
                }
              },
              grid: {
                //show: false,
                borderColor: "rgb(27, 36, 77)"
              },
              dataLabels: {
                enabled: true
              },
              tooltip: {
                enabled: false
              },
              xaxis: {
                categories: []
              }
          }
          var hasLocals = false
          var localNamesCount = 0

          //loop locals
          for (var j = 0; j < dists[i].local_munics.length; j++) {
            var locMunic = dists[i].local_munics[j]
            
            if(locMunic.local_munic !== "") {
              hasLocals = true

              //push vals
              locseries[0].data.push(locMunic.confirmed*1)
              locseries[1].data.push(locMunic.recovered*1)
              locseries[2].data.push(locMunic.deceased*1)

              //break up the cities text
              if(locMunic.city !== "") {
                var parts = locMunic.city.split(",")
                parts.unshift(locMunic.local_munic + " : ")
                locchartOptions.xaxis.categories.push(parts)
                localNamesCount += parts.length
              }
              else {
                locchartOptions.xaxis.categories.push(locMunic.local_munic)
              }
            }
          }

          //set dist vals
          dists[i].hasLocals = hasLocals
          dists[i].localsSeries = locseries
          dists[i].localChartOptions = locchartOptions
          
          var cheight = localNamesCount * 30
          if(cheight < 400) {
            cheight = 400
          }
          dists[i].localChartHeight = cheight

        }

        //get the chart data
        var valsC = []
        var valsR = []
        var valsD = []
        var cols = []
        for (var i = 0; i < dists.length; i++) {
          valsC.push(dists[i].district_munic_confirmed)
          valsR.push(dists[i].district_munic_recovered)
          valsD.push(dists[i].district_munic_deceased)
          cols.push(dists[i].district_munic)
        }

        //set the data
        selProv.districts = dists;

        self.selectedProvince = selProv;

        self.dialog = true;

        //set the graph data
        self.series = [{ name: "Confirmed", data: valsC },{ name: "Recovered", data: valsR },{ name: "Deaths", data: valsD }];
        self.chartOptions = {
        ...self.chartOptions,
        ...{
          xaxis: {
            categories: cols
          }
        }
      };

      setTimeout(function(){
          self.$refs.scrollTopHeader.scrollIntoView({ block: "start", behavior: 'smooth' });
      }, 1000)
    }
  }
};
</script>
